import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SelectInput from '../components/SelectInput';
import '../styles/infoReserva.css';
import TextInput from '../components/TextInput';

const InfoReserva = () => {
    const [formData, setFormData] = useState({ codigoPais: '', rut: '' });
    const [reservaData, setReservaData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [paises, setPaises] = useState([]);

    const bearerToken = process.env.REACT_APP_BEARER_TOKEN;

    // Función para manejar el cambio en ambos inputs
    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [id]: value,
        }));
    };

    useEffect(() => {
        const fetchPaises = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL_PAISES}`, {
                    headers: { Authorization: `Bearer ${bearerToken}` }
                });
                setPaises(response.data); // Asumiendo que el array de países está en response.data
            } catch (err) {
                console.error('Error al cargar la lista de países:', err);
            }
        };
        fetchPaises();
    }, [bearerToken]);

    // Función para manejar la búsqueda de la reserva
    const handleSearch = async () => {
        setLoading(true);
        setError(null);
        
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL_INFO_RESERVA_CLIENTE_POR_PAIS}`, {
                headers: { Authorization: `Bearer ${bearerToken}` },
                params: { pai_codigo: formData.codigoPais, int_nrodocidentidad: formData.rut }
            });
            setReservaData(response.data);
        } catch (err) {
            setError('Error al cargar la información de la reserva.');
            console.error('Error al cargar la información de la reserva:', err);
        } finally {
            setLoading(false);
        }
    };

    // Función para manejar el evento "Enter" en los inputs
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <div className="info-reserva-container">
            <h1>Buscar Reserva por Cliente</h1>
            <div className="search-bar">
                <SelectInput
                    id="codigoPais"
                    label="País"
                    options={paises}
                    value={formData.codigoPais}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    valueKey="codigoPais"
                    labelKey="denominacionPais"
                />
                <label className="infoReserva-label" htmlFor="rut">Rut:</label>
                <TextInput
                    className="infoReserva-input"
                    type="text"
                    id="rut"
                    value={formData.rut}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    placeholder="Ingrese rut del cliente" 
                />
                <button className="infoReserva-button" onClick={handleSearch} disabled={loading}>
                    {loading ? 'Buscando...' : 'Buscar'}
                </button>
            </div>
            {error && <p className="error">{error}</p>}
            {reservaData && (
                <div className="json-container">
                    <pre>{JSON.stringify(reservaData, null, 2)}</pre>
                </div>
            )}
        </div>
    );
};

export default InfoReserva;
